/**
 * Manual block-production peer requests for the Token Supply admin controls.
 */
var EXPLORER_ENSURE_TEST_MODE_REQUEST = 'explorer-ensure-test-mode';
var EXPLORER_SUBMIT_FEE_TRANSACTION_REQUEST = 'explorer-submit-fee-transaction';
var EXPLORER_PRODUCE_BLOCK_REQUEST = 'explorer-new-block-with-no-gt';
var EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST = 'explorer-new-block-with-gt';
function isSpamInstalled(app) {
  var _app$modules;
  return Boolean(app === null || app === void 0 || (_app$modules = app.modules) === null || _app$modules === void 0 ? void 0 : _app$modules.returnModule('spam'));
}
function isProductionNodeEnv() {
  var nodeEnv = String(process.env.NODE_ENV || '').trim().toLowerCase();
  return nodeEnv === 'prod' || nodeEnv === 'production';
}
function normalizeHostname(value) {
  var raw = String(value || '').trim().toLowerCase();
  if (!raw) {
    return '';
  }
  if (raw === '::1' || raw === '[::1]') {
    return '::1';
  }
  try {
    var url = new URL(raw.includes('://') ? raw : "http://".concat(raw));
    return String(url.hostname || '').replace(/^\[|\]$/g, '').toLowerCase();
  } catch (err) {
    return raw.split('/')[0].split(':')[0];
  }
}
function getManualTestingHost(app) {
  var _app$options, _app$options2;
  if ((app === null || app === void 0 ? void 0 : app.BROWSER) == 1 && typeof window !== 'undefined') {
    var _window, _window2;
    var browserHost = ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname) || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.host);
    if (browserHost) {
      return normalizeHostname(browserHost);
    }
  }
  return normalizeHostname((app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.server) === null || _app$options === void 0 || (_app$options = _app$options.endpoint) === null || _app$options === void 0 ? void 0 : _app$options.host) || (app === null || app === void 0 || (_app$options2 = app.options) === null || _app$options2 === void 0 || (_app$options2 = _app$options2.server) === null || _app$options2 === void 0 ? void 0 : _app$options2.host) || '');
}
function isAllowedManualTestingHost(host) {
  var hostname = normalizeHostname(host);
  return hostname === 'localhost' || hostname.endsWith('.localhost') || hostname === '127.0.0.1' || hostname === '::1' || hostname.includes('staging') || hostname.includes('testnet');
}

/**
 * Browser: whether manual block controls may be shown.
 */
function canShowManualBlockControls(app, mod) {
  if (!app || !(mod !== null && mod !== void 0 && mod.enable_manual_testing)) {
    return false;
  }
  if (!isAllowedManualTestingHost(getManualTestingHost(app))) {
    return false;
  }
  if (isSpamInstalled(app)) {
    return false;
  }
  if (app.BROWSER == 0 && isProductionNodeEnv()) {
    return false;
  }
  return true;
}

/**
 * Server: whether Explorer may enter test mode or honor produce requests.
 */
function allowsManualTestingOnServer(app, mod) {
  if (!app || !(mod !== null && mod !== void 0 && mod.enable_manual_testing)) {
    return false;
  }
  if (!isAllowedManualTestingHost(getManualTestingHost(app))) {
    return false;
  }
  if (isSpamInstalled(app)) {
    return false;
  }
  if (app.BROWSER == 0 && isProductionNodeEnv()) {
    return false;
  }
  return true;
}
module.exports = {
  EXPLORER_ENSURE_TEST_MODE_REQUEST: EXPLORER_ENSURE_TEST_MODE_REQUEST,
  EXPLORER_SUBMIT_FEE_TRANSACTION_REQUEST: EXPLORER_SUBMIT_FEE_TRANSACTION_REQUEST,
  EXPLORER_PRODUCE_BLOCK_REQUEST: EXPLORER_PRODUCE_BLOCK_REQUEST,
  EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST: EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST,
  normalizeHostname: normalizeHostname,
  getManualTestingHost: getManualTestingHost,
  isAllowedManualTestingHost: isAllowedManualTestingHost,
  canShowManualBlockControls: canShowManualBlockControls,
  allowsManualTestingOnServer: allowsManualTestingOnServer
};